/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, lazy, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Header from '../Header/Header'
import SideBar from '../Sidebar/SideBar'
import Logout from '../Atoms/Logout/Logout'
import BankRequestIndividual from '../../pages/BankRequestIndividual/BankRequestIndividual'
import RedeemAmountIndividual from '../../pages/RedeemAmountIndividual/RedeemAmountIndividual'
import RedeemRequestMerchant from '../../pages/RedeemRequestMerchant/RedeemRequestMerchant'
import RedeemAmountMerchant from '../../pages/RedeemAmountMerchant/RedeemAmountMerchant'
import Wallet2Wallet from '../../pages/Wallet2Wallet/Wallet2Wallet'
import SwapHistory from '../../pages/SwapHistory/SwapHistory'
import ExpressCheckoutHistory from '../../pages/ExpressCheckoutHistory/ExpressCheckoutHistory'
import P2PHistory from '../../pages/P2PHistory/P2PHistory'
import MerchantSellerHistory from '../../pages/MerchantSellerHistory/MerchantSellerHistory'
import MerchantBuyerHistory from '../../pages/MerchantBuyerHistory/MerchantBuyerHistory'
import FeesSetting from '../../pages/FeesSetting/FeesSetting'
import MerchantCharges from '../../pages/MerchantCharges/MerchantCharges'
import SupplyMinedPKRD from '../../pages/SupplyMinedPKRD/SupplyMinedPKRD'
import AltWalletHoldings from '../../pages/AltWalletHoldings/AltWalletHoldings'
import MerchantApprovedAPI from '../../pages/MerchantApprovedAPI/MerchantApprovedAPI'
import PaymentGateway from '../../pages/paymentGateway/PaymentGateway'
import CsEmail from '../../pages/CsEmail/CsEmail'
import Backups from '../../pages/Backups/Backups'
import MerchantApps from '../../pages/MerchantApps/MerchantApps'
import RestrictAcctUnusualActivity from '../../pages/RestrictAcctUnusualActivity/RestrictAcctUnusualActivity'
import UpcomingIdExpires from '../../pages/UpcomingIdExpires/UpcomingIdExpires'
import DetailsPage from '../../pages/MonitoringUnit/components/DetailsPage'
import { authHeader, connectNotificationSocket, socketConnection, userId } from '../../_helpers'
import SubMerchantsApproval from '../../pages/MerchantApps/Components/SubMerchantsApproval'
import Loader from '../Atoms/Loader'
// import Checkout from '../../pages/Checkout/Checkout'

const Dashboard = lazy(() => import('../../pages/dashboard/Dashboard'))
const App = lazy(() => import('../../pages/App/App'))
const Charts = lazy(() => import('../../pages/Charts/Charts'))
const Bootstrap = lazy(() => import('../../pages/Boostrap/Bootstrap'))
const DisputeCategory = lazy(() =>
  import('../../pages/DisputeCategory/DisputeCategory')
)
const Dispute = lazy(() => import('../../pages/Dispute/Dispute'))
const FiaManagement = lazy(() =>
  import('../../pages/FiatManagement/FiaManagement')
)
const PaymentMethod = lazy(() =>
  import('../../pages/PaymentMethod/PaymentMethod')
)
const Advertisement = lazy(() =>
  import('../../pages/advertisement/Advertisement')
)
const AppSetting = lazy(() => import('../../pages/AppSetting/AppSetting'))
const TermsTagManagement = lazy(() =>
  import('../../pages/TermsTagManagement/TermsTagManagement')
)
const SecurityManagement = lazy(() =>
  import('../../pages/SecurityManagement/SecurityManagement')
)
const LoginHistory = lazy(() => import('../../pages/LoginHistory/LoginHistory'))
const Order = lazy(() => import('../../pages/Order/Order'))
const DisputeRaisedList = lazy(() =>
  import('../../pages/DisputeRaisedList/DisputeRaisedList')
)
const CoinManagement = lazy(() =>
  import('../../pages/CoinManagement/coinManagement')
)
const ActiveUserList = lazy(() =>
  import('../../pages/ActiveUser/ActiveUserList')
)
const TransactionList = lazy(() =>
  import('../../pages/TransactionList/TransactionList')
)
const ContactUs = lazy(() => import('../../pages/ContactUs/ContactUs'))
const SecurityQuestion = lazy(() =>
  import('../../pages/SecurityQuestion/SecurityQuestion')
)
const SwappingList = lazy(() => import('../../pages/Swapping/SwappingList'))
const CoinTrade = lazy(() => import('../../pages/CoinTrade/CoinTrade'))
const UserDetails = lazy(() => import('../../pages/UserDetails/UserDetails'))
const MonitoringUnit = lazy(() =>
  import('../../pages/MonitoringUnit/MonitoringUnit')
)
const Merchant = lazy(() => import('../../pages/Merchant/Merchant'))
const Notification = lazy(() => import('../../pages/Notification/Notification'))
const UserManagementList = lazy(() =>
  import('../../pages/UserManagement/UserManagement')
)
const BankManagement = lazy(() =>
  import('../../pages/BankManagement/BankManagement')
)
const KycManagement = lazy(() =>
  import('../../pages/KYCManagement/KycManagement')
)
const AdminUserManagement = lazy(() =>
  import('../../pages/AdminUserAccess/index')
)
const AdminAccess = lazy(() =>
  import('../../pages/AdminUserAccess/AdminAccess')
)
const P2PChatInterface = lazy(() =>
  import('../../pages/P2PHistory/components/ChatSupport')
)

const AddFundExpressHistory = lazy(() => import('../../pages/AddFundExpressHistory/AddFundExpressHistory'))

const TransactionDispute = lazy(() => import('../../pages/TransactionDispute/TransactionDispute'))

function Layout() {
  const [isModalLogout, setIsModalLogout] = useState(false)
  const openLogout = () => setIsModalLogout(true)
  const closeLogout = () => setIsModalLogout(false)
  const socket = socketConnection(true)
  const location = useLocation()

  useEffect(() => {
    if (userId && authHeader()?.Authorization) {
      connectNotificationSocket(userId)
      socket.on('notification_connected', data => {
        console.log(data.message);
      })
    }

  }, [location.pathname, userId, socket])


  return (
    <>
      <div className='flex h-screen overflow-hidden bg-[#F9F9FC]'>
        <SideBar />
        <div className='flex flex-col flex-1 w-full overflow-hidden h-screen '>
          <Header openLogout={openLogout} />
          <div className='overflow-hidden overflow-y-auto max-h-100
  [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:bg-green-600/50 [&::-webkit-scrollbar-thumb]:rounded-full'>
            <Suspense
              fallback={
                <div className='flex items-center justify-center h-full'>
                  <Loader loading={true} />
                </div>
              }
            >
              <Routes>
                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/app' element={<App />} />
                <Route path='/user-management' element={<UserManagementList />} />
                <Route path='/charts' element={<Charts />} />
                <Route path='/bootstrap' element={<Bootstrap />} />
                <Route path='/coin-management' element={<CoinManagement />} />
                <Route path='/coin-trade-limit' element={<CoinTrade />} />
                <Route path='/user-management/user-details/:id' element={<UserDetails />} />
                <Route path='/swap-management' element={<SwappingList />} />
                <Route path='/active-user' element={<ActiveUserList />} />
                <Route path='/transaction-list' element={<TransactionList />} />
                <Route path='/customer-support' element={<ContactUs />} />
                <Route
                  path='/security-questions'
                  element={<SecurityQuestion />}
                />
                <Route path='/kyc-management' element={<KycManagement />} />
                <Route
                  path='/Redeem-Bank-Request-(Individual)'
                  element={<BankRequestIndividual />}
                />
                <Route
                  path='/Redeem-Bank-Request-(Merchant)'
                  element={<RedeemRequestMerchant />}
                />
                <Route
                  path='/Redeem-Amount-(Individual)'
                  element={<RedeemAmountIndividual />}
                />
                <Route
                  path='/Redeem-Amount-(Merchant)'
                  element={<RedeemAmountMerchant />}
                />
                <Route path='/Wallet-to-Wallet' element={<Wallet2Wallet />} />
                <Route path='/Swap-History' element={<SwapHistory />} />
                <Route
                  path='/Add-Fund-(Express-History)'
                  element={<AddFundExpressHistory />}
                />

                <Route
                  path='/Express-Checkout-History'
                  element={<ExpressCheckoutHistory />}
                />
                <Route
                  path='/Merchant-Seller-History'
                  element={<MerchantSellerHistory />}
                />
                <Route
                  path='/merchant-payment-history'
                  element={<MerchantBuyerHistory />}
                />
                <Route path='/p2p-history' element={<P2PHistory />} />
                <Route
                  path='/Supply-/-Mined-(PKRD)'
                  element={<SupplyMinedPKRD />}
                />
                <Route
                  path='/Alt-Wallet-Holdings'
                  element={<AltWalletHoldings />}
                />
                <Route
                  path='/Merchant-Approved-(API)'
                  element={<MerchantApprovedAPI />}
                />
                <Route path='/Payment-Gateway' element={<PaymentGateway />} />
                <Route path='/CS-Email' element={<CsEmail />} />
                <Route path='/backups' element={<Backups />} />
                <Route path='/Fees-Setting' element={<FeesSetting />} />
                <Route path='/Merchant-Charges' element={<MerchantCharges />} />
                <Route path='/merchant-apps' element={<MerchantApps />} />
                <Route
                  path='/restrict-acct-unusual-activity'
                  element={<RestrictAcctUnusualActivity />}
                />
                <Route
                  path='/upcoming-id-expires'
                  element={<UpcomingIdExpires />}
                />
                <Route path='/bank-management' element={<BankManagement />} />
                <Route path='/dispute-category' element={<DisputeCategory />} />
                <Route path='/dispute-message' element={<Dispute />} />
                <Route
                  path='/p2p-dispute'
                  element={<DisputeRaisedList />}
                />
                {/* inner pages */}
                <Route
                  path='/p2p-history/p2p-chat'
                  element={<P2PChatInterface />}
                />
                <Route
                  path='/dispute-raised-list/p2p-chat'
                  element={<P2PChatInterface />}
                />
                <Route path='/fiat-management' element={<FiaManagement />} />
                <Route path='/payment-method' element={<PaymentMethod />} />
                <Route path='/advertisement' element={<Advertisement />} />
                <Route path='/app-setting' element={<AppSetting />} />
                <Route path='/terms-tags' element={<TermsTagManagement />} />
                <Route path='/orders' element={<Order />} />
                <Route path='/merchant' element={<Merchant />} />
                <Route
                  path='/profile-security-management'
                  element={<SecurityManagement />}
                />
                <Route path='/login-history' element={<LoginHistory />} />
                <Route path='/notification' element={<Notification />} />

                {/* Sanju */}
                <Route
                  path='/admin-user-management'
                  element={<AdminUserManagement />}
                />
                <Route
                  path='/admin-user-management/admin-access'
                  element={<AdminAccess />}
                />
                <Route path='/monitoring-unit' element={<MonitoringUnit />} />
                <Route
                  path='/monitoring-unit/view-details'
                  element={<DetailsPage />}
                />
                <Route
                  path='/merchant-apps/sub-merchants'
                  element={<SubMerchantsApproval />}
                />

                <Route
                  path='/transaction-dispute'
                  element={<TransactionDispute />}
                />
              </Routes>
            </Suspense>
            <Logout isOpen={isModalLogout} closeModal={closeLogout} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout
